export default "__VITE_ASSET__CYzcXFM5__"